import { getSellerSalesRepresentative } from '../../../../../../../../../services/modules/salesRepresentatives/salesRepresentatives.repository';
import { SalesRepresentativeToOffline } from '../../../../../../../../sales-representative/sales-representative.types';
import { OfflineDatabaseSalesRepresentative } from '../../../../../../../database/offlineDatabase/types/offlineDatabaseSalesRepresentative.types';
import { offlineSalesRepresentativeRepository } from '../../../../../../../repositories/offlineSalesRepresentative.repository';
import { QueryKeysAndFnOptions } from '../../../useQueryKeysAndFnToCache.types';
import { generateQueryKeysAndFnToPaginatedEndpoint } from '../../generateQueryKeysAndFnToPaginatedEndpoint';
import { QueryKeysAndFnGenerator, QueryKeysAndFnGeneratorParams } from './types';
import { mapSalesRepresentativeToOfflineData } from './utils/mapOfflineSalesRepresentative.util';

export class SalesRepresentativesQueryKeysAndFnGenerator implements QueryKeysAndFnGenerator {
  constructor(
    private readonly params: Pick<QueryKeysAndFnGeneratorParams, 'priority' | 'isSeller'>,
  ) {}

  async generateQueryKeysAndFn(): Promise<QueryKeysAndFnOptions> {
    const currentUserSalesRepResponse = await getSellerSalesRepresentative();
    if (!currentUserSalesRepResponse.ok) {
      throw currentUserSalesRepResponse.data;
    }

    const currentUserSalesRep = currentUserSalesRepResponse.data;

    if (this.params.isSeller) {
      return [
        {
          priority: this.params.priority,
          useReactQuery: false,
          queryKey: ['sales-representative/mine/v1', undefined],
          queryFn: async () => {
            if (!currentUserSalesRep) {
              return;
            }

            await offlineSalesRepresentativeRepository.save(
              this.toOfflineData(currentUserSalesRep, true),
            );
          },
        },
      ];
    }

    const queryKeysAndFnToBrandAdmin =
      await generateQueryKeysAndFnToPaginatedEndpoint<SalesRepresentativeToOffline>({
        url: '/sales-representatives/offline/v1',
        priority: this.params.priority,
        fnToSaveData: async (data) => {
          await offlineSalesRepresentativeRepository.saveAll(
            data.map((salesRep) =>
              this.toOfflineData(salesRep, salesRep.id === currentUserSalesRep?.id),
            ),
          );
        },
      });

    return queryKeysAndFnToBrandAdmin;
  }

  private toOfflineData(
    data: SalesRepresentativeToOffline,
    isMine: boolean,
  ): OfflineDatabaseSalesRepresentative {
    return mapSalesRepresentativeToOfflineData({
      id: data.id,
      name: data.name,
      code: data.code,
      isMine,
    });
  }
}
